import type { LC_ScheduleListItemOut, LC_ScheduleDetailOut, Schedule, ScheduleDetail, SchedulesPage } from './schedule.types';
import type { LC_PagedResult } from '@/api/shared';

/** Maps a backend transport DTO to the internal Schedule model */
export function mapScheduleItemToModel(item: LC_ScheduleListItemOut): Schedule {
  return {
    id: item.scheduleId,
    name: item.name,
    startTime: item.startTime,
    endTime: item.endTime,
    collationMinutes: item.breakMinutes,
    isTwoDays: item.isTwoDaySchedule,
    hasCollationMark: item.hasBreakMarkings,
    timezone: item.timeZoneDescription,
  };
}

/** Maps a paginated backend response to the internal SchedulesPage model */
export function mapPagedSchedules(
  pagedResult: LC_PagedResult<LC_ScheduleListItemOut>,
): SchedulesPage {
  return {
    data: pagedResult.data?.map(mapScheduleItemToModel) ?? [],
    totalRecords: pagedResult.pagination?.totalRecords ?? 0,
  };
}

/** Maps a schedule detail DTO to the internal ScheduleDetail model */
export function mapScheduleDetailOutToModel(dto: LC_ScheduleDetailOut): ScheduleDetail {
  return {
    id: dto.scheduleId,
    name: dto.name,
    isTwoDaySchedule: dto.isTwoDaySchedule,
    timeZoneId: dto.timeZoneId,
    shiftGroupId: dto.shiftGroupId,
    startTime: dto.startTime,
    entryThresholdStart: dto.entryThresholdStart,
    entryThresholdEnd: dto.entryThresholdEnd,
    entryOvertimeTolerance: dto.entryOvertimeTolerance,
    entryDelayTolerance: dto.entryDelayTolerance,
    endTime: dto.endTime,
    exitThresholdStart: dto.exitThresholdStart,
    exitThresholdEnd: dto.exitThresholdEnd,
    exitOvertimeTolerance: dto.exitOvertimeTolerance,
    earlyExitTolerance: dto.earlyExitTolerance,
    // Colacion
    breakMinutes: dto.breakMinutes,
    breakStartTime: dto.breakStartTime,
    breakEndTime: dto.breakEndTime,
    breakEntryThresholdStart: dto.breakEntryThresholdStart,
    breakEntryThresholdEnd: dto.breakEntryThresholdEnd,
    breakExitThresholdStart: dto.breakExitThresholdStart,
    breakExitThresholdEnd: dto.breakExitThresholdEnd,
    discountBreakDelay: dto.discountBreakDelay,
    hasBreakMarkings: dto.hasBreakMarkings,
    associateShift: dto.associateShift,
  };
}

